// app/javascript/controllers/hero_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator", "toggle"]

  connect() {
    this.index = 0
    this.interval = 5000
    this.timer = null

    this.showSlide(this.index)
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.stop()

    this.timer = setInterval(() => {
      this.next()
    }, this.interval)

    if (this.hasToggleTarget) {
      this.toggleTarget.textContent = "⏸"
    }
  }

  stop() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  next() {
    this.index = (this.index + 1) % this.slideTargets.length
    this.showSlide(this.index)
  }

  prev() {
    this.index = (this.index - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.index)

    if (this.timer) this.start()
  }

  go(event) {
    const nextIndex = parseInt(event.currentTarget.dataset.index, 10)
    if (Number.isNaN(nextIndex)) return

    this.index = nextIndex
    this.showSlide(this.index)

    if (this.timer) this.start()
  }

  toggle() {
    if (this.timer) {
      this.stop()
      if (this.hasToggleTarget) this.toggleTarget.textContent = "▶"
    } else {
      this.start()
    }
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      const isActive = i === index

      slide.classList.toggle("is-active", isActive)
      slide.classList.remove("is-entering")

      if (isActive) {
        // CSS animation を毎回再実行させるための最小限リセット
        void slide.offsetWidth
        slide.classList.add("is-entering")
      }
    })

    this.indicatorTargets.forEach((indicator, i) => {
      indicator.classList.toggle("is-active", i === index)
    })
  }
}
